<script>
import Multiselect from "vue-multiselect";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import ItemList from "@/components/modals/item-list.vue";
import ItemCategory from "@/components/modals/item-category-with-personnels.vue";
import Unit from "@/components/modals/unit.vue";
import Swal from "sweetalert2";
import { cloneDeep, groupBy } from "lodash";
import PackageModal from "@/components/modals/package-modal.vue";
import PackageItems from "@/router/views/office/office-widgets/package-items.vue";
import { required } from "vuelidate/lib/validators";

const greaterThanZero = (value) => value.replace(/,/g, "") > 0;
export default {
    props: {
        selectedTransfer: {
            type: Object,
            default: () => {
                return {};
            },
        },
        selectedApiId: {
            type: Number,
            default: 0,
        },
        selectTransferBudget: {
            type: Boolean,
            default: false,
        },
        carts: {
            type: Array,
            default: () => {
                return [];
            },
        }
    },
    components: {
        Multiselect,
        MaskedInput,
        ItemList,
        ItemCategory,
        Unit,
        PackageModal,
        PackageItems
    },
    beforeMount() {
        window.addEventListener("beforeunload", (event) => {
            if (!this.openModal) return;
            event.preventDefault();
            event.returnValue = "";
        });
    },
    data() {
        return {
            submitted: false,
            itemOption: 0,
            isActive: false,
            visibilityOff: 0,
            packages: [],
            packageItems: [],
            selectedPackage: null,
            viewAll: false,
            accountCategories: [],
            transferBudget: false,
            goodError: false,
            packageItemIndex: 0,
            budgetVirtual: 0,
            carouselStyle: "",
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            selectedResourceStatus: "",
            itemIndex: -1,
            itemCategory: "",
            unit: "",
            lastConsumed: null,
            // resource item details
            itemDetails: [],
            itemDetailFields: [
                {
                    key: "month.monthName",
                    label: "Month",
                    variant: "primary",
                },
                {
                    key: "quantity",
                    label: "Qty",
                    variant: "primary",
                    thStyle: { width: "120px" },
                },
                {
                    label: "Total",
                    key: "total",
                    variant: "primary",
                    thStyle: { width: "200px" },
                },
                {
                    key: "actions",
                    variant: "primary",
                    thStyle: { width: "90px" },
                    thClass: "text-center",
                    tdClass: "text-center",
                },
            ],
            detailError: false,
            detail: {
                id: 0,
                monthId: 0,
                quantity: "1",
                totalAmt: "0",
            },
            detailCopy: {
                id: 0,
                monthId: 0,
                quantity: "1",
                totalAmt: "0",
            },
            detailIndex: -1,
            apiIndex: -1,
            months: [],
            viewMenu: false,
            top: "0px",
            left: "0px",
            viewDetail: false,
            openModal: false,
            showBLIScreen: false,
            optionStyle: "top:50%;left:50%;transform:translate(-50%,-50%);",
            slideBLI: false,
            bliBtn: "",
            showBLIBtn: false,
            selectedBLI: null,
            filterBudget: "",
            //budget
            currentPageBudget: 1,
            perPageBudget: 10,
            budgetData: [],
            budgetBusy: false,
            selectedBudgetAmount: 0,
            item: {
                id: 0,
                itemName: "",
                description: "",
                unitId: "",
                type: "NON-CSE",
                itemCategoryId: "",
                unitCost: "0",
                cseId: 0,
                departmentPlanningApiId: 0,
                departmentPlanningBudgetItemId: 0,
                isProcurable: true,
            },
            subType: "",
            budgetCopy: 0,
            groupedBudget: [],
            deletedItems: 0,
            budgetItemId: 0,
        }
    },
    validations: {
        item: {
            itemName: { required },
            description: { required },
            unitId: { required },
            type: { required },
            itemCategoryId: { required },
            unitCost: { required, greaterThanZero },
        },
        detail: {
            month: { required },
            quantity: { required, greaterThanZero },
        },
        subType: { required },
    },
    computed: {
        filteredBudget() {
            let data = this.groupedBudget;
            var total = this.currentPageBudget * this.perPageBudget;
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterBudget.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageBudget, total);
            if (this.currentPageBudget > 1 && currentData.length == 0) {
                total = (this.currentPageBudget - 1) * this.perPageBudget;
                currentData = data.slice(total - this.perPageBudget, total);
            }
            return currentData;
        },
        rowsBudget() {
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                return this.filteredBudget.length;
            } else {
                return this.groupedBudget.length;
            }
        },
        totalBudget() {
            var totalBalance = this.selectedBLI ? this.selectedBLI.balance : 0;
            totalBalance += this.detailCopy.totalAmt ? parseFloat(this.detailCopy.totalAmt) : 0;
            return totalBalance -= (this.packageTotal() + parseFloat(this.getExactAmt(this.detail.totalAmt)));
        },
        quantityTotal() {
            var data = this.itemDetails;
            return data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.quantity);
            }, 0);
        },
        amountTotal() {
            var data = this.itemDetails;
            var sum = data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.totalAmt);
            }, 0);
            return sum;
        },
        filteredItemDetails() {
            let data = this.itemDetails;
            return data.sort((a, b) => a.monthId - b.monthId);
        },
        detailChecker() {
            return this.itemDetails.length;
        },
        isProcurableOption: {
            get() {
                if (this.item.isProcurable) {
                    return 1;
                }
                return 2;
            },
            set(newValue) {
                if (newValue == 1) {
                    this.item.isProcurable = true;
                } else {
                    this.item.isProcurable = false;
                }
            }
        },
        isMixedOption: {
            get() {
                if (this.item.isMixed) {
                    return 1;
                }
                return 2;
            },
            set(newValue) {
                if (newValue == 1) {
                    this.item.isProcurable = true;
                    this.item.isMixed = true;
                } else {
                    this.item.isMixed = false;
                }
            }
        },
    },
    created() {
        this.$store
            .dispatch("month/GetAllMonths")
            .then((res) => {
                this.months = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
        this.$store
            .dispatch(
                "settings/GetInflationRate")
            .then((res) => {
                this.inflationRate = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
    },
    methods: {
        onResetResourceItem(type = "reset") {
            this.item = {
                id: type === "reset" ? 0 : this.itemId,
                itemName: "",
                description: "",
                unitId: "",
                type: "NON-CSE",
                itemCategoryId: "",
                unitCost: "0",
                cseId: 0,
                departmentPlanningApiId: 0,
                departmentPlanningBudgetItemId: 0,
                isProcurable: true,
                subType: "Goods",
            };
            this.subType = "Goods";
            this.selectedBudgetAmount += this.itemDetails.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.totalAmt);
            }, 0);
            this.itemDetails = [];
            this.itemDetailCopy = [];
            this.unit = "";
            this.itemCategory = {};
            this.$v.item.$reset();
            this.$v.subType.$reset();
            this.onResetDetail();
            let lastC = cloneDeep(this.lastConsumed);
            if (this.selectedBLI) {
                this.selectedBLI.balance += lastC;
                this.budgetVirtual = cloneDeep(this.selectedBLI.balance);
                this.lastConsumed = 0;
            }
        },
        onResetDetail() {
            this.detail = {
                id: 0,
                monthId: 0,
                quantity: "1",
                totalAmt: "0",
            };
            this.detailCopy = {
                id: 0,
                monthId: 0,
                quantity: "1",
                totalAmt: "0",
            };
            this.$v.detail.$reset();
            this.detailIndex = -1;
        },
        selectMonth(data) {
            this.detail.monthId = data.id;
            this.calculateTotal();
        },
        getItems() {
            // this.$refs.itemList.changeCycle(this.$store.state.data.cycle);
            this.$bvModal.show("item-list-modal");
        },
        dropItem(data, fromCart = false) {
            this.item.itemName = data.itemName;
            this.item.description = data.description;
            this.item.unitId = data.unitId;
            this.item.itemCategoryId = data.itemCategoryId;
            this.item.isProcurable = data.isProcurable;
            this.item.cseId = data.id;
            this.item.unitCost = this.numberWithCommas(data.unitCost);
            this.unit = data.unit.shortName;
            this.itemCategory = data.itemCategory;
            this.subType = data.subType;
            this.item.thumbnail = data.thumbnail;
            this.item.thumbnailUrl = `${this.$store.state.data.rootFileDirectory}Procurement/${data.thumbnail}`;
            if (data.inDbm) {
                this.item.type = "CSE";
            } else {
                this.item.type = "NON-CSE";
            }
            if (fromCart) {
                this.item.fromCart = true;
                this.item.cartItemId = data.cartItemId;
            } else {
                this.item.fromCart = false;
                this.item.cartItemId = 0;
            }
            this.calculateTotal();
            this.calculateAll(this.item.unitCost);
        },
        getUnit() {
            this.$refs.unit.getData();
            this.$bvModal.show("unit-modal");
        },
        dropUnit(data) {
            this.unit = data.shortName;
            this.item.unitId = data.id;
        },
        getItemCategory() {
            this.$bvModal.show("item-category-modal");
        },
        dropItemCat(data) {
            this.itemCategory = data;
            this.item.itemCategoryId = data.id;
        },
        async closeModal() {
            let proceed = false;
            if (!this.viewDetail) {
                if (
                    (this.itemOption == 1 && this.selectedPackage) ||
                    (this.itemOption == 2 && this.itemDetails.length > 0 && this.itemId == 0)
                ) {
                    await Swal.fire({
                        title: "Are you sure?",
                        text: "You will lose your progress!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#5c636a",
                        cancelButtonColor: "#7367f0",
                        confirmButtonText: "Yes, close it!",
                    }).then((result) => {
                        if (result.value) {
                            proceed = true;
                        }
                    });
                } else {
                    proceed = true;
                }
            } else {
                proceed = true;
            }
            if (!proceed) {
                return;
            }
            if (this.itemId > 0) {
                if (this.deletedItems > 0) {
                    let totalQuantity = 0;
                    let totalAmount = 0;
                    this.itemDetails.forEach(item => {
                        if (item.id > 0) {
                            totalQuantity += item.quantity;
                            totalAmount += item.totalAmt;
                        }
                    })
                    this.$emit('close-update', { id: this.itemId, quantity: totalQuantity, amount: totalAmount })
                }
                if (this.budgetItemId != this.item.departmentPlanningBudgetItemId) {
                    this.$emit('refresh-all')
                }
            }
            if (this.totalBudget < 0) {
                this.$emit('refresh-all');
            }
            this.closeAdding();
        },
        closeAdding() {
            document.body.classList.remove('resource-open');
            this.slideBLI = false;
            this.showBLIBtn = false;
            this.viewAll = false;
            this.isActive = false;
            this.visibilityOff = 0;
            this.itemOption = 0;
            this.optionStyle =
                "top:50%;left:50%;transform:translate(-50%,-50%);";
            this.openModal = false;
            this.selectedBLI = null;
            this.budgetIndex = -1;
            this.budgetCopy = 0;
            this.selectedBudgetAmount = 0;
            this.budgetVirtual = 0;
        },
        getFundSourceTotal(row) {
            let total = 0;
            row.data.forEach((x) => {
                x.data.forEach((z) => {
                    total += z.amount - z.balance;
                });
            });
            return total;
        },
        getFundSourceBalance(row) {
            let balance = 0;
            row.data.forEach((x) => {
                x.data.forEach((z) => {
                    balance += z.balance;
                });
            });
            return balance;
        },
        transferIfs(row) {
            if (this.selectedTransfer.id) {
                if (this.selectedTransfer.id == row.id) {
                    return true;
                }
                return false;
            } else {
                if (this.item.id > 0) {
                    if (row.id == (this.selectedBLI && this.selectedBLI.id)) {
                        return false;
                    }
                    return true;
                }
                return false;
            }
        },
        selectCategory(data) {
            this.item.itemCategoryId = data.id;
        },
        onPageChange(event, type) {
            this.detailError = false;
            this.goodError = false;
            let packageIndex = cloneDeep(event);
            if (type === "forward") {
                this.updateNewInfo(this.packageItems[event]);
                packageIndex = event + 1;
                this.packageItemIndex++;
            } else if (type === "backward") {
                this.updateNewInfo(this.packageItems[event]);
                packageIndex = event - 1;
                this.packageItemIndex--;
            } else {
                this.packageItemIndex = event;
            }
            this.carouselStyle = `transform:translateX(-${this.packageItems[packageIndex].left}px);`;
            this.itemDetails = [];
            this.onResetDetail();
            this.assignPackageItem(this.packageItems[packageIndex]);
        },
        updateNewInfo(row) {
            row.itemDetails = this.itemDetails
                ? cloneDeep(this.itemDetails)
                : [];
            row.item.unitCost = this.item.unitCost;
            row.item.unitId = this.item.unitId;
            row.item.itemCategoryId = this.item.itemCategoryId;
            row.item.unit.shortName = this.unit;
            row.item.description = this.item.description;
            row.item.type = this.item.type;
        },
        assignPackageItem(row) {
            this.item = {
                id: 0,
                itemName: row.item.itemName,
                description: row.item.description,
                unitId: row.item.unitId,
                itemCategoryId: row.item.itemCategoryId,
                cseId: row.item.id,
                isProcurable: row.item.isProcurable,
                subType: row.item.subType,
            };
            if (row.item.inDbm) {
                this.item.type = "CSE";
            } else {
                this.item.type = "NON-CSE";
            }
            this.item.unitCost = this.numberWithCommas(row.item.unitCost);
            this.unit = row.item.unit.shortName;
            this.itemCategory = row.item.itemCategory;
            this.itemDetails = cloneDeep(row.itemDetails);
        },
        packageTotal() {
            if (this.selectedBLI) {
                let balance = cloneDeep(this.selectedBLI.balance);
                let total = cloneDeep(this.budgetVirtual);
                return parseFloat(balance) - parseFloat(total);
            } else {
                return 0;
            }
        },
        resetPackage() {
            this.packageItems = [];
            this.selectedPackage = null;
            this.onResetResourceItem();
        },
        async onSubmitPackage() {
            this.updateNewInfo(this.packageItems[this.packageItemIndex]);
            this.detailError = false;
            this.goodError = false;
            this.submitted = true;
            if (this.budgetVirtual < 0) {
                return this.showToast("Budget is not enough!", "error");
            }
            let errorArr = [];
            let emptyDetails = 0;
            this.packageItems.forEach((item, index) => {
                if (item.itemDetails.length == 0) {
                    emptyDetails++;
                }
                if (
                    !this.item.isMixed &&
                    item.item.isProcurable &&
                    this.selectedBLI.fundClassification.goodMax > 0 &&
                    this.getExactAmt(item.item.unitCost) >=
                    this.selectedBLI.fundClassification.goodMax &&
                    item.item.subType &&
                    item.item.subType === 'Goods'
                ) {
                    errorArr.push(index);
                }
                if (
                    !this.item.isMixed &&
                    item.item.isProcurable &&
                    this.selectedBLI.fundClassification.goodMin > 0 &&
                    this.getExactAmt(item.item.unitCost) <
                    this.selectedBLI.fundClassification.goodMin &&
                    item.item.subType &&
                    item.item.subType === 'Goods'
                ) {
                    errorArr.push(index);
                }
            });
            if (emptyDetails == this.packageItems.length) {
                this.onPageChange(this.packageItemIndex);
                if (this.detailChecker == 0) {
                    this.detailError = true;
                    return;
                }
            }
            if (errorArr.length > 0) {
                this.onPageChange(errorArr[0]);
                this.$v.item.$touch();
                if (this.$v.item.$invalid) {
                    return;
                }
                if (
                    !this.item.isMixed &&
                    this.item.isProcurable &&
                    this.selectedBLI.fundClassification.goodMax > 0 &&
                    this.getExactAmt(this.item.unitCost) >=
                    this.selectedBLI.fundClassification.goodMax &&
                    this.subType &&
                    this.subType === 'Goods'
                ) {
                    this.goodError = true;
                    return;
                }
                if (
                    !this.item.isMixed &&
                    this.item.isProcurable &&
                    this.selectedBLI.fundClassification.goodMin > 0 &&
                    this.getExactAmt(this.item.unitCost) <
                    this.selectedBLI.fundClassification.goodMin &&
                    this.subType &&
                    this.subType === 'Goods'
                ) {
                    this.goodError = true;
                    return;
                }
            }
            let proceed = true;
            if (emptyDetails > 0) {
                await Swal.fire({
                    title: "Warning!",
                    text: `There are ${emptyDetails} item(s) with no details. Do you want to continue?`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#f1b44c",
                    cancelButtonColor: "#5c636a",
                    confirmButtonText: "Yes, proceed!",
                }).then((result) => {
                    if (result.value) {
                        proceed = true;
                    } else {
                        proceed = false;
                    }
                });
            }
            let data = [];
            if (proceed) {
                // for await(const item of this.packageItems){
                //     if(item.itemDetails.length > 0){
                //         item.item.apiResourceDetails = item.itemDetails;
                //         data.push({...item.item, apiId: this.selectedApiId, deliveryUnitBudgetItemId: this.selectedBLI.id});
                //     }
                // }
                // this.submitPackageResources(data);
                for await (const item of this.packageItems) {
                    if (item.itemDetails.length > 0) {
                        this.assignPackageItem(item);
                        await this.onSubmitResourceItem();
                    }
                }
                this.closeAdding();
            }
        },
        submitPackageResources(data) {
            this.$store
                .dispatch("apiresource/CreateMultiplePPMPItem", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.showToast("Successfully added!", "success");
                    this.itemLoading = true;
                    this.$emit('update-package');
                })
                .catch((e) => {
                    this.showToast("Something went wrong!", "error");
                    this.submitted = false;
                });
        },
        showPackageModal() {
            this.$refs.pckModal.getData();
            this.$bvModal.show("package-modal");
        },
        async getItemDetails(id) {
            await this.$store
                .dispatch(
                    "preplanningapiresourcedetail/GetApiResourceDetailByApiResource",
                    id
                )
                .then((res) => {
                    res.data.forEach((item) => {
                        if (this.item.type === 'CSE') {
                            let total = parseFloat(item.quantity) *
                                parseFloat(this.getExactAmt(this.item.unitCost));
                            let inflation = total * (this.inflationRate / 100);
                            item.totalAmt = total + inflation;
                        } else {
                            item.totalAmt =
                                parseFloat(item.quantity) *
                                parseFloat(this.getExactAmt(this.item.unitCost));
                        }
                        item.total = this.formatCurrency(item.totalAmt);
                    });
                    this.itemDetailCopy = cloneDeep(res.data);
                    this.itemDetails = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        updateItemDetail(row) {
            // this.selectedBudgetAmount += parseFloat(row.item.totalAmt);
            this.detailCopy = cloneDeep(row.item);
            this.detail = cloneDeep(row.item);
            this.detail.quantity = row.item.quantity.toString();
            this.detail.totalAmt = this.numberWithCommas(row.item.totalAmt);
            this.detailIndex = this.itemDetails.indexOf(row.item);
        },
        deleteItemDetail(row) {
            var index = this.itemDetails.indexOf(row.item);
            this.selectedBudgetAmount += parseFloat(row.item.totalAmt);
            this.budgetVirtual += parseFloat(row.item.totalAmt);
            this.itemDetails.splice(index, 1);
            // this.showToast("Successfully deleted!", "success");
            // Swal.fire({
            //     title: "Are you sure?",
            //     text: "You won't be able to revert this!",
            //     icon: "warning",
            //     showCancelButton: true,
            //     confirmButtonColor: "#dc3545",
            //     cancelButtonColor: "#5c636a",
            //     confirmButtonText: "Yes, delete it!",
            // }).then((result) => {
            //     if (result.value) {
            //         if (row.item.id > 0) {
            //             this.$store
            //                 .dispatch(
            //                     "preplanningapiresourcedetail/DeleteApiResourceDetail",
            //                     row.item.id
            //                 )
            //                 .then((res) => {
            //                     if (res.data.error) {
            //                         return this.showToast(
            //                             res.data.errorMessage,
            //                             "error"
            //                         );
            //                     }
            //                     if (res.status == 204) {
            //                         this.selectedBudgetAmount += parseFloat(
            //                             row.item.totalAmt
            //                         );
            //                         this.itemDetails.splice(index, 1);
            //                         let copy = this.itemDetailCopy.find(
            //                             (x) => x.id == row.item.id
            //                         );
            //                         if (copy) {
            //                             this.$emit('specific-item-update', {id: this.itemId, column: 'total', value: parseFloat(copy.totalAmt), type: 'deduct'})
            //                         }
            //                         this.budgetData[this.budgetIndex].balance =
            //                             cloneDeep(this.selectedBudgetAmount);
            //                         this.showToast(
            //                             "Successfully deleted!",
            //                             "success"
            //                         );
            //                     }
            //                     this.deletedItems++;
            //                 })
            //                 .catch((err) => {
            //                     this.showToast("Cannot be deleted!", "error");
            //                 });
            //         } else {

            // }
            // }
            // });
        },
        openBLI() {
            this.slideBLI = !this.slideBLI;
            if (this.selectedTransfer.id) {
                this.bliBtn = `position:fixed;top:${100}px;left:0;`;
            } else {
                let toggleBtn = this.$refs.slideBLI.getClientRects();
                this.bliBtn = `position:fixed;top:${toggleBtn[0].top}px;left:0;`;
                if (this.item.id > 0) {
                    this.transferBudget = true;
                } else {
                    this.transferBudget = false;
                }
            }
            if (this.slideBLI) {
                this.showBLIScreen = true;
                setTimeout(() => {
                    this.showBLIBtn = true;
                }, 400);
            } else {
                this.showBLIBtn = false;
                setTimeout(() => {
                    this.showBLIScreen = false;
                }, 500);
            }
        },
        filteredBudgetChild(info) {
            let data = cloneDeep(info);
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterBudget.toUpperCase());
                });
            }
            return data;
        },
        moveToLeft() {
            this.resetPackage();
            if (!this.isActive) {
                this.optionStyle = "top:0;left:0;transform:translate(0,0);";
                this.visibilityOff = 1;
                setTimeout(() => {
                    this.isActive = true;
                    this.itemOption = 1;
                }, 500);
                setTimeout(() => {
                    this.viewAll = true;
                }, 900);
                setTimeout(() => {
                    if (!this.selectedBLI) {
                        this.openBLI();
                    } else {
                        this.budgetVirtual = cloneDeep(
                            this.selectedBLI.balance
                        );
                    }
                }, 1000);
            } else {
                this.isActive = false;
                this.viewAll = false;
                this.itemOption = 0;
                setTimeout(() => {
                    this.optionStyle =
                        "top:50%;left:50%;transform:translate(-50%,-50%);";
                }, 300);
                setTimeout(() => {
                    this.visibilityOff = 0;
                }, 750);
            }
        },
        moveToRight() {
            return;
            this.onResetResourceItem();
            if (!this.isActive) {
                this.optionStyle =
                    "top:0;left:100%;transform:translate(-100%,0);";
                this.visibilityOff = 2;
                setTimeout(() => {
                    this.isActive = true;
                    this.itemOption = 2;
                }, 500);
                setTimeout(() => {
                    this.viewAll = true;
                }, 900);
                setTimeout(() => {
                    if (!this.selectedBLI) {
                        this.openBLI();
                    } else {
                        this.budgetVirtual = cloneDeep(
                            this.selectedBLI.balance
                        );
                    }
                }, 1000);
            } else {
                this.isActive = false;
                this.viewAll = false;
                this.itemOption = 0;
                setTimeout(() => {
                    this.optionStyle =
                        "top:50%;left:50%;transform:translate(-50%,-50%);";
                }, 250);
                setTimeout(() => {
                    this.visibilityOff = 0;
                }, 750);
            }
        },
        async selectPackage(row) {
            this.packageItems = [];
            this.selectedPackage = cloneDeep(row);
            await this.$store
                .dispatch("packageitem/GetPackageItemByPackage", row.id)
                .then((res) => {
                    let width =
                        this.$refs.carouselSample.getBoundingClientRect().width;
                    res.data.forEach((item, index) => {
                        item.item.unitCost = item.item.unitCost.toString();
                        item.itemDetails = [];
                        item.left = width * index;
                    });
                    this.packageItems = res.data;
                    this.packageItemIndex = 0;
                    if (res.data.length > 0) {
                        this.onPageChange(0);
                        // this.assignPackageItem(this.packageItems[0]);
                    } else {
                        return this.showToast("No item found!", "error");
                    }
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getItemInfo(props, type) {
            this.lastConsumed = 0;
            if (type === "view") {
                this.viewDetail = true;
            } else {
                this.viewDetail = false;
            }
            this.lastConsumed = cloneDeep(props.totalWithInflation);
            this.item = cloneDeep(props);
            this.item.unitCost = this.numberWithCommas(props.unitCost);
            this.unit = props.unit.shortName;
            this.subType = props.subType;
            this.itemId = props.id;
            this.budgetItemId = cloneDeep(props.departmentPlanningBudgetItemId)
            let budgetIndex = this.budgetData.findIndex((x) => x.id == props.departmentPlanningBudgetItemId);
            this.budgetIndex = budgetIndex;
            this.selectedBLI = this.budgetData[budgetIndex];
            this.itemCategory = props.itemCategory;
            this.selectedBudgetAmount = cloneDeep(this.budgetData[budgetIndex].balance);
            this.budgetVirtual = cloneDeep(this.budgetData[budgetIndex].balance);
            this.openModal = true;
            this.isActive = true;
            this.itemOption = 2;
            this.visibilityOff = 2;
            this.optionStyle = "top:0;left:100%;transform:translate(-100%,0);";
            this.viewAll = true;
            this.deletedItems = 0;
            props.departmentPlanningApiResourceDetails.map(item => {
                if (props.type === 'CSE') {
                    let total = parseFloat(item.quantity) *
                        parseFloat(this.getExactAmt(this.item.unitCost));
                    let inflation = total * (this.inflationRate / 100);
                    item.totalAmt = total + inflation;
                } else {
                    item.totalAmt =
                        parseFloat(item.quantity) *
                        parseFloat(this.getExactAmt(this.item.unitCost));
                }
                item.total = this.formatCurrency(item.totalAmt);
                item.month = this.months.find(x => x.id == item.monthId);
            })
            this.itemDetailCopy = cloneDeep(props.departmentPlanningApiResourceDetails);
            this.itemDetails = cloneDeep(props.departmentPlanningApiResourceDetails);
            // await this.getItemDetails(props.id);
        },
        async getAllBudgets(cycle, departmentId) {
            this.budgetData = [];
            this.budgetBusy = true;
            await this.$store
                .dispatch("departmentplanningbudgetitem/GetAllDepartmentPlanningBudgetItem", { cycle, departmentId })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((item) => {
                        item.fundClass = item.fundClassification.classification;
                        item.filterKey = `${item.fundSource} ${item.accountGroup} ${item.fundClass}`;
                    });
                    this.budgetData = res.data;
                    var groupedFS = groupBy(res.data, "fundSource");
                    var grouped = [];
                    var id = 1;
                    var FCID = 1;
                    for (const key in groupedFS) {
                        var sumBalance = 0;
                        var sumAllocated = 0;
                        var filterKey = "";
                        groupedFS[key].forEach((a) => {
                            sumBalance += a.balance;
                            sumAllocated += a.amount;
                            filterKey += `${a.fundSource} ${a.accountGroup} ${a.fundClass}`;
                        });
                        var group = groupBy(groupedFS[key], "fundClass");
                        var FC = [];
                        for (const y in group) {
                            var filterY = "";
                            group[y].forEach((a) => {
                                filterY += `${a.fundSource} ${a.accountGroup} ${a.fundClass}`;
                            });
                            FC.push({
                                id: FCID++,
                                data: group[y],
                                key: y,
                                filterKey: filterY,
                            });
                        }
                        grouped.push({
                            id: id++,
                            fsName: key,
                            data: FC,
                            balance: sumBalance,
                            allocated: sumAllocated,
                            showData: false,
                            filterKey: filterKey,
                        });
                    }
                    this.groupedBudget = grouped;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            this.budgetBusy = false;
        },
        async onSubmitResourceItem() {
            this.detailError = false;
            this.goodError = false;
            this.submitted = true;
            this.$v.item.$touch();
            if (this.$v.item.$invalid) {
                return;
            }
            if (this.item.isProcurable) {
                this.$v.subType.$touch();
                if (this.$v.subType.$invalid) {
                    return;
                }
                this.item.subType = cloneDeep(this.subType);
            } else {
                this.item.subType = "";
            }
            if (this.detailChecker == 0) {
                return (this.detailError = true);
            }
            if (this.remainingBalance() < 0 && this.selectedBLI && !this.selectedBLI.allowedToExceed) {
                return;
            }
            if (
                !this.item.isMixed &&
                this.item.isProcurable &&
                this.selectedBLI.fundClassification.goodMax > 0 &&
                this.getExactAmt(this.item.unitCost) >= this.selectedBLI.fundClassification.goodMax &&
                this.subType &&
                this.subType === 'Goods'
            ) {
                return this.goodError = true;
            }
            if (
                !this.item.isMixed &&
                this.item.isProcurable &&
                this.selectedBLI.fundClassification.goodMin > 0 &&
                this.getExactAmt(this.item.unitCost) < this.selectedBLI.fundClassification.goodMin &&
                this.subType &&
                this.subType === 'Goods'
            ) {
                return this.goodError = true;
            }
            this.pageLoader(true);
            var data = cloneDeep(this.item);
            data.unitCost = this.getExactAmt(data.unitCost);
            data.departmentPlanningApiResourceDetails = [];
            this.itemDetails.forEach(item => {
                data.departmentPlanningApiResourceDetails.push(item);
            })
            if (this.item.type === 'CSE') {
                data.inflation = this.inflationRate;
            }
            data.departmentPlanningApiId = this.selectedApiId;
            data.departmentPlanningBudgetItemId = this.selectedBLI.id;
            if (this.item.id > 0) {
                await this.$store
                    .dispatch("departmentplanningapiresource/UpdateDepartmentPlanningApiResource", data)
                    .then((res) => {
                        if (res.data.error) {
                            this.pageLoader(false);
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.budgetCopy = this.totalBudget;
                        res.data.totalQuantity = this.itemDetails.reduce(
                            (pv, cv) => {
                                return parseFloat(pv) + parseFloat(cv.quantity);
                            },
                            0
                        );
                        res.data.financeTemplateBudgetItem = {
                            fundSource: this.selectedBLI.fundSource,
                            fundClass: this.selectedBLI.fundClass,
                            accountGroup: this.selectedBLI.accountGroup,
                            accountId: this.selectedBLI.id,
                        };
                        res.data.itemCategory = this.itemCategory;
                        let total = parseFloat(res.data.totalQuantity) * parseFloat(res.data.unitCost);
                        if (res.data.inflation > 0) {
                            let inflation = (this.inflationRate / 100) * total;
                            res.data.totalWithInflation = total + inflation;
                            res.data.totalInflation = inflation;
                            res.data.total = total;
                        } else {
                            res.data.totalWithInflation = total;
                            res.data.totalInflation = 0;
                            res.data.total = total;
                        }
                        this.$emit('update-item', res.data);
                        this.submitDetails(res.data.id, 1, res.data.totalWithInflation);
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                        this.submitted = false;
                        this.pageLoader(false);
                    });
            } else {
                await this.$store
                    .dispatch(
                        "departmentplanningapiresource/CreateDepartmentPlanningApiResource",
                        data
                    )
                    .then((res) => {
                        if (res.data.error) {
                            this.pageLoader(false);
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        this.budgetCopy = this.totalBudget;
                        res.data.totalQuantity = this.itemDetails.reduce(
                            (pv, cv) => {
                                return parseFloat(pv) + parseFloat(cv.quantity);
                            },
                            0
                        );
                        res.data.financeTemplateBudgetItem = {
                            fundSource: this.selectedBLI.fundSource,
                            fundClass: this.selectedBLI.fundClass,
                            accountGroup: this.selectedBLI.accountGroup,
                            accountId: this.selectedBLI.id,
                        };
                        let total = parseFloat(res.data.totalQuantity) * parseFloat(res.data.unitCost);
                        if (res.data.inflation > 0) {
                            let inflation = (this.inflationRate / 100) * total;
                            res.data.totalWithInflation = total + inflation;
                            res.data.totalInflation = inflation;
                            res.data.total = total;
                        } else {
                            res.data.totalWithInflation = total;
                            res.data.totalInflation = 0;
                            res.data.total = total;
                        }
                        res.data.itemCategory = this.itemCategory;
                        if (this.item.fromCart) {
                            this.$emit('remove-from-cart', this.item.cartItemId);
                        }
                        this.$emit('add-item', res.data);
                        this.submitDetails(res.data.id, 0, res.data.totalWithInflation);
                    })
                    .catch((e) => {
                        this.showToast("Something went wrong!", "error");
                        this.submitted = false;
                        this.pageLoader(false);
                    });
            }
        },
        async submitDetails(id, opt, total) {
            // var sum = 0;
            // for await (const item of this.itemDetails) {
            //     sum += parseFloat(item.totalAmt);
            //     item.prePlanningApiResourceId = id;
            //     if (item.id > 0) {
            //         this.$store.dispatch(
            //             "preplanningapiresourcedetail/UpdateApiResourceDetail",
            //             item
            //         );
            //     } else {
            //         this.$store.dispatch(
            //             "preplanningapiresourcedetail/CreateApiResourceDetail",
            //             item
            //         );
            //     }
            // }
            let budgetIndex = this.budgetData.findIndex((e) => e.id === this.selectedBLI.id);
            if (opt == 1) {
                this.showToast("Successfully updated!", "success");
                this.budgetData[budgetIndex].total -= this.lastConsumed;
                this.budgetData[budgetIndex].total += total;
                this.budgetData[budgetIndex].balance += this.lastConsumed;
                this.budgetData[budgetIndex].balance -= total;
            } else {
                this.showToast("Successfully created!", "success");
                this.budgetData[budgetIndex].total += total;
                this.budgetData[budgetIndex].balance -= total;
            }
            this.$emit('update-totals', { apiId: this.selectedApiId });
            this.$emit('specific-item-update', { id: id, value: total, column: 'total', type: 'replace' })
            this.lastConsumed = null;
            if (this.itemOption == 2) {
                this.closeAdding();
            }
            this.submitted = false;
            this.pageLoader(false);
        },
        calculateTotal() {
            let unitCost = this.item.unitCost ? this.getExactAmt(this.item.unitCost) : 0;
            let quantity = this.detail.quantity ? this.getExactAmt(this.detail.quantity) : 0;
            let totalAmt = 0;
            if (this.item.type === 'CSE') {
                let total = parseFloat(unitCost) * parseFloat(quantity);
                let inflation = parseFloat(total) * (this.inflationRate / 100);
                totalAmt = total + inflation;
            } else {
                totalAmt = parseFloat(unitCost) * parseFloat(quantity);
            }
            this.detail.totalAmt = this.numberWithCommas(totalAmt);
        },
        calculateAll($event) {
            if (this.detailIndex > -1) { this.onResetDetail(); }
            this.goodError = false;
            let amount = $event ? this.getExactAmt($event) : 0;
            let qty = this.detail.quantity ? this.getExactAmt(this.detail.quantity) : 0;
            let totalAmt = 0;
            if (this.item.type === 'CSE') {
                let total = amount * qty
                let inflation = parseFloat(total) * (this.inflationRate / 100);
                totalAmt = total + inflation;
            } else {
                totalAmt = amount * qty
            }
            this.detail.totalAmt = this.numberWithCommas(totalAmt);
            var sum = this.itemDetails.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.totalAmt);
            }, 0);
            this.selectedBudgetAmount += sum;
            this.budgetVirtual += sum;
            var data = this.itemDetails;
            var newSum = 0;
            data.forEach((item) => {
                if (this.item.type === 'CSE') {
                    let total = parseFloat(amount) * parseFloat(item.quantity);
                    let inflation = parseFloat(total) * (this.inflationRate / 100);
                    item.totalAmt = total + inflation;
                } else {
                    item.totalAmt = parseFloat(amount) * parseFloat(item.quantity);
                }
                item.total = this.formatCurrency(item.totalAmt);
                newSum += item.totalAmt;
            });
            this.selectedBudgetAmount -= newSum;
            this.budgetVirtual -= newSum;
        },
        onSubmitItemDetail() {
            this.submitted = false;
            this.goodError = false;
            // if (this.selectedPPMPStatus === "POSTED") {
            //     return this.showToast(
            //         "Already Posted! Contact Procurement for more info",
            //         "warning"
            //     );
            // }
            // if (this.selectedPPMPStatus === "APPROVED") {
            //     return this.showToast(
            //         "Already Approved! Contact Procurement for more info",
            //         "warning"
            //     );
            // }
            if (!this.item.isMixed && this.item.isProcurable &&
                this.selectedBLI.fundClassification.goodMax > 0 &&
                this.getExactAmt(this.item.unitCost) >= this.selectedBLI.fundClassification.goodMax &&
                this.subType && this.subType === 'Goods'
            ) {
                this.submitted = true;
                this.goodError = true;
                return;
            }
            if (
                !this.item.isMixed &&
                this.item.isProcurable &&
                this.selectedBLI.fundClassification.goodMin > 0 &&
                this.getExactAmt(this.item.unitCost) < this.selectedBLI.fundClassification.goodMin &&
                this.subType &&
                this.subType === 'Goods'
            ) {
                this.submitted = true;
                this.goodError = true;
                return;
            }
            this.$v.item.$touch();
            if (this.$v.item.$invalid) {
                return;
            }
            this.$v.detail.$touch();
            if (this.$v.detail.$invalid) {
                return;
            }
            if (this.totalBudget < 0) {
                return;
            }
            var data = cloneDeep(this.detail);
            data.totalAmt = this.getExactAmt(this.detail.totalAmt);
            data.quantity = this.getExactAmt(this.detail.quantity);
            data.total = this.formatCurrency(data.totalAmt);
            if (this.detailIndex > -1) {
                this.selectedBudgetAmount -= data.totalAmt;
                this.selectedBudgetAmount += parseFloat(this.detailCopy.totalAmt);
                this.budgetVirtual -= data.totalAmt;
                this.budgetVirtual += parseFloat(this.detailCopy.totalAmt);
                this.itemDetails.splice(this.detailIndex, 1, data);
            } else {
                var exist = this.itemDetails.find((x) => x.month.id == data.month.id);
                this.selectedBudgetAmount -= data.totalAmt;
                this.budgetVirtual -= data.totalAmt;
                if (!exist) {
                    this.itemDetails.push(data);
                } else {
                    var index = this.itemDetails.indexOf(exist);
                    var totalAmt = parseFloat(data.totalAmt) + parseFloat(this.itemDetails[index].totalAmt);
                    this.itemDetails[index].totalAmt = totalAmt;
                    var totalQty = parseFloat(data.quantity) + parseFloat(this.itemDetails[index].quantity);
                    this.itemDetails[index].quantity = totalQty;
                    this.itemDetails[index].total = this.formatCurrency(totalAmt);
                }
            }
            this.onResetDetail();
        },
        transferHere(row) {
            this.selectedTransferBudget = cloneDeep(row);
            this.lastConsumed = 0;
            let balance = cloneDeep(row.balance);
            if (balance - parseFloat(this.amountTotal) < 0) {
                this.showToast("Cannot transfer to this budget item!", "error");
                return;
            }
            this.passBudgetItem(row.id);
            this.viewItems(this.selectedTransferBudget);
        },
        passBudgetItem(id) {
            //present
            let budgetIndex = this.budgetData.findIndex((x) => x.id == id);
            let presentBudget = this.budgetData[budgetIndex];
            presentBudget.balance -= parseFloat(this.item.totalWithInflation);
            presentBudget.totalWithInflation += parseFloat(this.item.totalWithInflation);
            //past
            let pastBudgetIndex = this.budgetData.findIndex((x) => x.id == this.item.departmentPlanningBudgetItemId);
            this.budgetData[pastBudgetIndex].balance += parseFloat(this.item.totalWithInflation);
            this.budgetData[pastBudgetIndex].totalWithInflation -= parseFloat(this.item.totalWithInflation);
            this.item.financeTemplateBudgetItem = {
                fundSource: presentBudget.fundSource,
                fundClass: presentBudget.fundClass,
                accountGroup: presentBudget.accountGroup,
                accountId: presentBudget.id,
            };
            this.item.departmentPlanningBudgetItemId = presentBudget.id;
            this.item.unitCost = this.getExactAmt(this.item.unitCost);
        },
        viewItems(row) {
            this.selectedBLI = cloneDeep(row);
            this.budgetIndex = this.budgetData.findIndex((x) => x.id == row.id);
            this.budgetCopy = row.balance;
            this.selectedBudgetAmount = cloneDeep(row.balance) - parseFloat(this.amountTotal);
            this.budgetVirtual = cloneDeep(row.balance) - parseFloat(this.amountTotal);
            this.closeAllOE();
            this.openBLI();
        },
        closeAllOE() {
            this.groupedBudget.forEach((x) => {
                x.showData = false;
            });
        },
        async getAccountCategories(id) {
            this.accountCategories = [];
            this.accountCategoryLoading = true;
            this.itemCategory = {};
            this.item.itemCategoryId = "";
            await this.$store
                .dispatch("itemcategory/GetItemCategoryAccount", id)
                .then((res) => {
                    this.accountCategories = res.data;
                    if (res.data.length > 0) {
                        // this.itemCategory = res.data[0];
                        this.itemCategory = res.data[0];
                        this.item.itemCategoryId = res.data[0].id;
                    }
                    this.accountCategoryLoading = false;
                })
                .catch((err) => {
                    this.accountCategoryLoading = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        async addNewItem() {
            this.onResetResourceItem();
            this.detailError = false;
            this.openModal = true;
            this.viewDetail = false;
            document.body.classList.add('resource-open');
            // for deletion if package is a must
            this.optionStyle =
                "top:0;left:100%;transform:translate(-100%,0);";
            this.visibilityOff = 2;
            this.isActive = true;
            this.itemOption = 2;
            this.viewAll = true;
            this.pageLoader(true);
            await this.wait(250);
            if (!this.selectedBLI) {
                this.openBLI();
            } else {
                this.budgetVirtual = cloneDeep(this.selectedBLI.balance);
            }
            this.pageLoader(false);
        },
        selectionOfProc(no) {
            if (this.isMixedOption == 1) return;
            if (this.viewDetail) return;
            this.onResetResourceItem(this.item.id > 0 ? 'edit' : 'reset');
            this.isProcurableOption = no;
        },
        selectionOfMixed(no) {
            if (this.viewDetail) return;
            this.onResetResourceItem(this.item.id > 0 ? 'edit' : 'reset');
            this.isMixedOption = no;
        },
        remainingBalance() {
            if (this.selectedBLI) {
                let balance = cloneDeep(this.item.id != 0 ? this.selectedBLI.balance + this.lastConsumed : this.selectedBLI.balance);
                let total = cloneDeep(this.itemOption == 1 ? this.packageTotal() : this.amountTotal);
                return parseFloat(balance) - parseFloat(total);
            } else {
                return 0;
            }
        }
    }
}
</script>

<template>
    <div>
        <div class="position-fixed" style="top: 20px; right: 10px; z-index: 2000"
            v-if="openModal && visibilityOff == 0">
            <a href="javascript:void(0);" @click="closeModal"><i class="bx bx-x text-white"
                    style="font-size: 4rem"></i></a>
        </div>
        <div class="position-fixed custom-option d-flex" v-if="openModal">
            <div class="p-3">
                <div class="px-4 position-absolute py-3 custom-modal-api" :style="optionStyle"
                    :class="{ 'h-100': viewAll }">
                    <div class="d-flex align-items-center">
                        <div class="
                                bg-purple
                                d-flex
                                align-items-center
                                rounded
                                h-content
                                option-animation
                                justify-content-between
                                position-relative
                            " :class="{
                                'w-option-particular flex-row py-3': isActive,
                                'flex-column py-5 justify-content-center w-250px':
                                    !isActive,
                                'd-none': itemOption == 2,
                                invisible: visibilityOff == 2,
                            }">
                            <div class="d-flex align-items-center" :class="{
                                'flex-column justify-content-center':
                                    !isActive,
                            }">
                                <i class="bx bx-package text-white" style="font-size: 4rem" :class="{
                                    'me-2 ms-3 font-size-24': isActive,
                                }"></i>
                                <h3 class="text-white mb-0">Package</h3>
                            </div>
                            <i class="
                                    bx bx-x
                                    font-size-24
                                    text-white
                                    px-3
                                    cursor-pointer
                                " v-if="viewAll" @click="closeModal"></i>
                            <div @click="moveToLeft" class="position-absolute cursor-pointer" style="inset: 0"
                                :class="{ 'w-50': viewAll }"></div>
                        </div>
                        <span class="mx-5 font-size-14 opacity-animation" :class="{ invisible: visibilityOff > 0 }"
                            v-if="!isActive">OR</span>
                        <div class="
                                bg-purple
                                d-flex
                                align-items-center
                                rounded
                                h-content
                                option-animation
                                justify-content-between
                                position-relative
                            " :class="{
                                'w-option-particular flex-row py-3': isActive,
                                'flex-column py-5 justify-content-center w-250px':
                                    !isActive,
                                'd-none': itemOption == 1,
                                invisible: visibilityOff == 1,
                            }">
                            <div class="d-flex align-items-center" :class="{
                                'flex-column justify-content-center':
                                    !isActive,
                            }">
                                <i class="bx bx-package text-white" style="font-size: 4rem" :class="{
                                    'me-2 ms-3 font-size-24': isActive,
                                }"></i>
                                <h3 class="text-white mb-0">Single Item</h3>
                            </div>
                            <i class="
                                    bx bx-x
                                    font-size-24
                                    text-white
                                    px-3
                                    cursor-pointer
                                " v-if="viewAll" @click="closeModal"></i>
                            <div @click="moveToRight" class="position-absolute cursor-pointer" style="inset: 0"
                                :class="{ 'w-50': viewAll }"></div>
                        </div>
                    </div>

                    <div class="position-relative mt-2 opacity-animation" :class="{ active: viewAll }" v-if="viewAll">
                        <div class="
                                d-flex
                                align-items-center
                                justify-content-between
                            ">
                            <div class="mb-3">
                                <h4 class="mb-0"
                                    :class="{ 'text-danger': remainingBalance() < 0 && selectedBLI && !selectedBLI.allowedToExceed }">
                                    Allocated Funds:
                                    <span class="text-warning" v-if="item.id > 0">
                                        {{ formatCurrency(selectedBLI && selectedBLI.balance + lastConsumed) }}
                                    </span>
                                    <span class="text-warning" v-else>{{
                                        formatCurrency(selectedBLI && selectedBLI.balance)
                                        }}</span>
                                    <span v-if="selectedBLI && selectedBLI.allowedToExceed">(Allowed to
                                        Exceed)</span>
                                </h4>
                                <h4 class="mb-0"
                                    :class="{ 'text-danger': remainingBalance() < 0 && selectedBLI && !selectedBLI.allowedToExceed }">
                                    Overall Total:
                                    <span class="text-warning" v-if="itemOption == 1">{{
                                        formatCurrency(packageTotal())
                                    }}</span>
                                    <span class="text-warning" v-if="itemOption == 2">{{ formatCurrency(amountTotal)
                                        }}</span>
                                </h4>
                                <h4 class="mb-0"
                                    :class="{ 'text-danger': remainingBalance() < 0 && selectedBLI && !selectedBLI.allowedToExceed }">
                                    Remaining Balance:
                                    <span class="text-warning">{{ formatCurrency(remainingBalance()) }}</span>
                                </h4>
                            </div>
                            <div class="d-flex align-items-center" v-if="!viewDetail">
                                <h5 class="mb-0 me-3">
                                    <span v-if="item.id == 0">{{
                                        selectedBLI && selectedBLI.id > 0 && selectTransferBudget
                                            ? "Select Another Budget"
                                            : "Select Budget Here"
                                    }}</span>
                                    <span v-else>
                                        Transfer to Another Budget
                                    </span>
                                    <i class="
                                            fas
                                            fa-hand-point-right
                                            pointing-animation
                                        "></i>
                                </h5>
                                <a href="javascript:void(0);" ref="slideBLI" @click="openBLI"><i class="
                                            bx bx-caret-left
                                            font-size-24
                                            py-3
                                            px-2
                                            rounded
                                            bg-secondary bg-soft
                                            text-white
                                        "></i></a>
                            </div>
                        </div>
                        <div v-if="selectedBLI && selectedBLI.id > 0" class="me-1 mb-3">
                            <div class="d-flex align-items-center">
                                <span class="
                                        bg-secondary
                                        text-white
                                        py-1
                                        px-2
                                        me-2
                                    ">{{ selectedBLI.fundSource }}</span>
                                <span class="bg-purple text-white py-1 px-2 me-2">{{ selectedBLI.fundClass }}</span>
                                <span class="bg-success text-white py-1 px-2 me-2">{{ selectedBLI.accountGroup }}</span>
                            </div>
                        </div>
                        <div class="row" v-if="itemOption == 1">
                            <div class="col-md-12">
                                <div class="card position-relative">
                                    <a href="javascript:void(0);" @click="
                                        onPageChange(
                                            packageItemIndex,
                                            'backward'
                                        )
                                        " class="
                                            position-absolute
                                            nav-left
                                            bg-white
                                            w-content
                                        " v-if="
                                            selectedPackage &&
                                            packageItemIndex > 0
                                        ">
                                        <i class="
                                                bx bx-chevron-left
                                                text-black
                                            " style="font-size: 4rem"></i>
                                    </a>
                                    <a href="javascript:void(0);" @click="
                                        onPageChange(
                                            packageItemIndex,
                                            'forward'
                                        )
                                        " class="
                                            position-absolute
                                            nav-right
                                            bg-white
                                            w-content
                                        " v-if="
                                            selectedPackage &&
                                            packageItemIndex <
                                            packageItems.length - 1
                                        ">
                                        <i class="
                                                bx bx-chevron-right
                                                text-black
                                            " style="font-size: 4rem"></i>
                                    </a>
                                    <div class="card-body" v-if="selectedPackage">
                                        <div class="
                                                d-flex
                                                align-items-center
                                                justify-content-between
                                            ">
                                            <div>
                                                <h4 class="mb-0">
                                                    {{ selectedPackage.name }}
                                                </h4>
                                                <small>{{
                                                    selectedPackage.description
                                                }}</small>
                                            </div>
                                            <div>
                                                <h4 class="mb-0">
                                                    {{
                                                        packageItemIndex + 1
                                                    }}/{{ packageItems.length }}
                                                </h4>
                                            </div>
                                        </div>
                                        <hr />
                                        <PackageItems />
                                        <hr />
                                        <div class="text-right">
                                            <button type="button" class="btn btn-primary" @click="onSubmitPackage">
                                                Save changes
                                            </button>
                                            <button type="button" class="btn btn-link" @click="closeModal">
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                    <div class="
                                            card-body
                                            d-flex
                                            align-items-center
                                            justify-content-center
                                        " style="height: calc(100vh - 220px)" v-else>
                                        <div class="
                                                d-flex
                                                flex-column
                                                justify-content-center
                                            ">
                                            <img src="@/assets/images/other-pics/box.png" style="height: 200px"
                                                class="cursor-pointer" alt="box" />
                                            <h4 class="mt-3 mb-0">
                                                Select Package
                                                <a href="javascript:void(0);" class="hoverable-link"
                                                    @click="showPackageModal">Here...</a>
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="
                            itemOption == 2 &&
                            selectedBLI &&
                            selectedBLI.id > 0
                        ">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body px-5">
                                        <div class="row">
                                            <div class="col-md-7">
                                                <div class="
                                                        row
                                                        mb-2
                                                    ">
                                                    <div class="col-md-4">
                                                        <div class="mb-2">
                                                            <label for="itemType" class="mb-0 fs-4">Mixed?</label>
                                                            <div class="d-flex gap-2 mt-1">
                                                                <div class="fs-5 px-3 py-1 border border-2 w-50 text-center"
                                                                    :class="{ 'border-warning': isMixedOption == 1, 'cursor-pointer': !viewDetail }"
                                                                    style="border-radius:5px;"
                                                                    @click="selectionOfMixed(1)">Yes</div>
                                                                <div class="fs-5 px-3 py-1 border border-2 w-50 text-center"
                                                                    :class="{ 'border-warning': isMixedOption == 2, 'cursor-pointer': !viewDetail }"
                                                                    style="border-radius:5px;"
                                                                    @click="selectionOfMixed(2)">No</div>
                                                            </div>
                                                        </div>
                                                        <div class="mb-2">
                                                            <label for="itemType" class="mb-0 fs-4">Procurable?</label>
                                                            <div class="d-flex gap-2 mt-1 w-100">
                                                                <div class="fs-5 px-3 py-1 border border-2 w-50 text-center"
                                                                    :class="{ 'border-warning': isProcurableOption == 1, 'cursor-pointer': isMixedOption == 2 && !viewDetail }"
                                                                    style="border-radius:5px;"
                                                                    @click="selectionOfProc(1)">Yes</div>
                                                                <div class="fs-5 px-3 py-1 border border-2 w-50 text-center"
                                                                    :class="{ 'border-warning': isProcurableOption == 2, 'cursor-pointer': isMixedOption == 2 && !viewDetail }"
                                                                    style="border-radius:5px;"
                                                                    @click="selectionOfProc(2)">No</div>
                                                            </div>
                                                        </div>
                                                        <div v-if="isProcurableOption == 1">
                                                            <label for="subType" class="mb-0">SubType</label>
                                                            <template
                                                                v-if="isMixedOption == 1 || isProcurableOption == 2 || $store.state.data.cycle == 2023">
                                                                <select class="form-select text-warning" id="subType"
                                                                    v-model="subType" placeholder="Select Sub Type..."
                                                                    :class="{ 'is-invalid': submitted && $v.subType.$error }">
                                                                    <option value="Goods">Goods</option>
                                                                    <option value="Services">Goods (General Support
                                                                        Services)</option>
                                                                    <option value="Consultancy">Consulting Services
                                                                    </option>
                                                                    <option value="Infrastructure">Infrastructure
                                                                        Projects</option>
                                                                </select>
                                                            </template>
                                                            <template v-else>
                                                                <select class="form-select text-warning" id="subType"
                                                                    :value="subType" placeholder="Select Sub Type..."
                                                                    :class="{ 'is-invalid': submitted && $v.subType.$error }"
                                                                    disabled>
                                                                    <option value="Goods">Goods</option>
                                                                    <option value="Services">Goods (General Support
                                                                        Services)</option>
                                                                    <option value="Consultancy">Consulting Services
                                                                    </option>
                                                                    <option value="Infrastructure">Infrastructure
                                                                        Projects</option>
                                                                </select>
                                                            </template>
                                                            <div v-if="submitted && $v.subType.$error"
                                                                class="invalid-feedback">
                                                                <span v-if="!$v.subType.required">This value is
                                                                    required.</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <div class="mb-2">
                                                            <label for="itemName" class="mb-0">Item Name</label>
                                                            <b-input-group>
                                                                <template #append>
                                                                    <b-button @click="getItems" variant="outline-info"
                                                                        v-if="!viewDetail && isProcurableOption == 1 && (isMixedOption == 2 || $store.state.data.cycle == 2023)">
                                                                        <i
                                                                            class="mdi mdi-clipboard-text-search-outline"></i>
                                                                    </b-button>
                                                                    <button type="button"
                                                                        class="btn btn-outline-success"
                                                                        title="Edit Descriptions"
                                                                        @click="item.cseId = 0"
                                                                        v-if="!viewDetail && item.cseId != 0 && $store.state.data.cycle == 2023">
                                                                        <i class="bx bx-pencil"></i>
                                                                    </button>
                                                                    <button type="button"
                                                                        class="btn btn-outline-success position-relative"
                                                                        title="Show Cart" @click="$emit('view-cart')"
                                                                        v-if="!viewDetail && isProcurableOption == 1 && (isMixedOption == 2 || $store.state.data.cycle == 2023)">
                                                                        <i class="bx bx-shopping-bag"></i>
                                                                        <small
                                                                            class="position-absolute badge bg-danger rounded-pill ms-1"
                                                                            style="top:4px;right:2px;font-size:8px;"
                                                                            v-if="carts.length != 0">{{ carts.length
                                                                            }}</small>
                                                                    </button>
                                                                    <b-button
                                                                        @click="onResetResourceItem(item.id != 0 ? 'edit' : 'reset')"
                                                                        variant="outline-danger" v-if="!viewDetail">
                                                                        <i class="bx bx-x"></i>
                                                                    </b-button>
                                                                </template>
                                                                <input
                                                                    v-if="(isProcurableOption == 1 && $store.state.data.cycle != 2023 && isMixedOption == 2) || viewDetail"
                                                                    disabled type="text" :value="item.itemName"
                                                                    class="form-control text-warning"
                                                                    :placeholder="`Search Item...`" />
                                                                <input v-else autocomplete="off" type="text"
                                                                    placeholder="Input Item Name/Search Item..."
                                                                    class="form-control text-warning"
                                                                    :class="{ 'is-invalid': $v.item.itemName.$error }"
                                                                    v-model="item.itemName"
                                                                    :disabled="item.cseId != 0" />
                                                            </b-input-group>
                                                            <div v-if="$v.item.itemName.$error"
                                                                class="invalid-feedback">
                                                                <span v-if="!$v.item.itemName.required">
                                                                    This value is required.
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <label for="description" class="mb-0">Description</label>
                                                            <textarea
                                                                v-if="(isProcurableOption == 1 && $store.state.data.cycle != 2023 && isMixedOption == 2) || viewDetail"
                                                                autocomplete="off" id="name" rows="6"
                                                                :value="item.description"
                                                                placeholder="Enter Description..."
                                                                class="form-control text-warning"
                                                                :class="{ 'is-invalid': $v.item.description.$error }"
                                                                disabled></textarea>
                                                            <textarea v-else autocomplete="off" id="name" rows="6"
                                                                v-model="item.description" :disabled="item.cseId != 0"
                                                                placeholder="Enter Description..."
                                                                class="form-control text-warning"
                                                                :class="{ 'is-invalid': $v.item.description.$error }"></textarea>
                                                            <div v-if="$v.item.description.$error"
                                                                class="invalid-feedback">
                                                                <span v-if="!$v.item.description.required">This value is
                                                                    required.</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <b-row class="mb-2">
                                                    <b-col sm="2">
                                                        <label for="unitId" class="mb-0">Unit</label>
                                                        <b-input-group>
                                                            <template #append
                                                                v-if="isMixedOption == 1 || isProcurableOption == 2 || $store.state.data.cycle == 2023">
                                                                <b-button @click="getUnit" variant="outline-info"
                                                                    :disabled="item.cseId != 0" v-if="!viewDetail">
                                                                    <i
                                                                        class="mdi mdi-clipboard-text-search-outline"></i>
                                                                </b-button>
                                                            </template>
                                                            <input autocomplete="off" type="text" disabled
                                                                placeholder="Search Unit..."
                                                                class="form-control text-warning"
                                                                :class="{ 'is-invalid': $v.item.unitId.$error }"
                                                                v-model="unit" />
                                                        </b-input-group>
                                                        <div v-if="$v.item.unitId.$error" class="invalid-feedback">
                                                            <span v-if="!$v.item.unitId.required">This value is
                                                                required.</span>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="6">
                                                        <label for="itemCategoryId" class="mb-0">Item Category</label>
                                                        <b-input-group>
                                                            <template #append
                                                                v-if="isMixedOption == 1 || isProcurableOption == 2 || $store.state.data.cycle == 2023">
                                                                <b-button @click="getItemCategory"
                                                                    variant="outline-info" :disabled="item.cseId != 0"
                                                                    v-if="!viewDetail">
                                                                    <i
                                                                        class="mdi mdi-clipboard-text-search-outline"></i>
                                                                </b-button>
                                                            </template>
                                                            <input autocomplete="off" type="text" disabled
                                                                placeholder="Search Item Category..."
                                                                class="form-control text-warning"
                                                                :class="{ 'is-invalid': $v.item.itemCategoryId.$error }"
                                                                v-model="itemCategory.name" />
                                                        </b-input-group>
                                                        <div v-if="$v.item.itemCategoryId.$error"
                                                            class="invalid-feedback">
                                                            <span v-if="!$v.item.itemCategoryId.required">This value is
                                                                required.</span>
                                                        </div>
                                                    </b-col>
                                                    <b-col sm="4">
                                                        <b-row>
                                                            <b-col sm="12">
                                                                <label for="unitId" class="mb-0">Unit Cost</label>
                                                                <masked-input
                                                                    v-if="isMixedOption == 1 || isProcurableOption == 2 || $store.state.data.cycle == 2023"
                                                                    autocomplete="off" id="unitCost" type="text"
                                                                    v-model="item.unitCost"
                                                                    class="form-control text-right text-warning"
                                                                    :class="{ 'is-invalid': $v.item.unitCost.$error || (submitted && goodError) }"
                                                                    @input="calculateAll($event)"
                                                                    :mask="currencyMask"></masked-input>
                                                                <input v-else disabled id="unitCost" type="text"
                                                                    class="form-control text-right text-warning"
                                                                    :value="item.unitCost"
                                                                    :class="{ 'is-invalid': $v.item.unitCost.$error || (submitted && goodError) }"
                                                                    :mask="currencyMask" />
                                                                <div v-if="$v.item.unitCost.$error"
                                                                    class="invalid-feedback">
                                                                    <span v-if="!$v.item.unitCost.required">This value
                                                                        is required.</span>
                                                                    <span v-if="!$v.item.unitCost.greaterThanZero">This
                                                                        value must be greater than zero.</span>
                                                                </div>
                                                                <div class="text-right position-relative" v-if="
                                                                    !item.isMixed &&
                                                                    item.isProcurable &&
                                                                    selectedBLI &&
                                                                    selectedBLI.fundClassification.goodMax > 0 &&
                                                                    subType && subType === 'Goods'
                                                                ">
                                                                    <small class="text-success">
                                                                        <b>
                                                                            Unit Cost must be lesser than
                                                                            {{
                                                                                formatCurrency(selectedBLI.fundClassification.goodMax)
                                                                            }}
                                                                        </b>
                                                                    </small>
                                                                    <i v-if="submitted && goodError"
                                                                        class="fas fa-hand-point-left pointing-animation me-2 font-size-16"></i>
                                                                </div>
                                                                <div class="
                                                                        text-right
                                                                        position-relative
                                                                    " v-if="
                                                                        !item.isMixed &&
                                                                        item.isProcurable &&
                                                                        selectedBLI &&
                                                                        selectedBLI.fundClassification.goodMin > 0 &&
                                                                        this.subType &&
                                                                        this.subType === 'Goods'
                                                                    ">
                                                                    <small class="
                                                                            text-success
                                                                        ">
                                                                        <b>Unit
                                                                            Cost
                                                                            must
                                                                            be
                                                                            equal
                                                                            or
                                                                            greater
                                                                            than
                                                                            {{
                                                                                formatCurrency(selectedBLI.fundClassification.goodMin)
                                                                            }}
                                                                        </b>
                                                                    </small>
                                                                    <i v-if="
                                                                        submitted &&
                                                                        goodError
                                                                    " class="
                                                                            fas
                                                                            fa-hand-point-left
                                                                            pointing-animation
                                                                            me-2
                                                                            font-size-16
                                                                        "></i>
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>
                                                </b-row>
                                                <div>
                                                    <textarea v-if="viewDetail" autocomplete="off" id="name" rows="2"
                                                        :value="item.note" placeholder="Enter Notes..."
                                                        class="form-control text-warning" disabled></textarea>
                                                    <textarea v-else autocomplete="off" id="name" rows="2"
                                                        v-model="item.note" placeholder="Enter Notes..."
                                                        class="form-control text-warning"></textarea>
                                                </div>
                                                <hr v-if="!viewDetail" />
                                                <form @submit.prevent="
                                                    onSubmitItemDetail
                                                " class="needs-validation" ref="fcForm" v-if="!viewDetail">
                                                    <b-row>
                                                        <b-col sm="4">
                                                            <label for="monthId" class="mb-0">Month
                                                            </label>
                                                            <multiselect v-model="detail.month
                                                                " :options="months
                                                                    " label="monthName" @select="
                                                                        selectMonth
                                                                    " track-by="id" value="id" deselect-label=""
                                                                select-label="" :allow-empty="false
                                                                    " :class="{
                                                                        'is-invalid':
                                                                            $v
                                                                                .detail
                                                                                .month
                                                                                .$error,
                                                                    }" />
                                                            <div v-if="
                                                                $v.detail
                                                                    .month
                                                                    .$error
                                                            " class="
                                                                    invalid-feedback
                                                                ">
                                                                <span v-if="
                                                                    !$v
                                                                        .detail
                                                                        .month
                                                                        .required
                                                                ">This value
                                                                    is
                                                                    required.</span>
                                                            </div>
                                                        </b-col>
                                                        <b-col sm="2">
                                                            <label for="qty" class="mb-0">Qty
                                                            </label>
                                                            <masked-input autocomplete="off" id="qty" type="text"
                                                                v-model="detail.quantity
                                                                    " class="
                                                                    form-control
                                                                    text-right
                                                                " :class="{
                                                                    'is-invalid':
                                                                        $v
                                                                            .detail
                                                                            .quantity
                                                                            .$error,
                                                                }" @input="
                                                                    calculateTotal()
                                                                    " :mask="currencyMask
                                                                        "></masked-input>
                                                            <div v-if="
                                                                $v.detail
                                                                    .quantity
                                                                    .$error
                                                            " class="
                                                                    invalid-feedback
                                                                ">
                                                                <span v-if="
                                                                    !$v
                                                                        .detail
                                                                        .quantity
                                                                        .required
                                                                ">This value
                                                                    is
                                                                    required.</span>
                                                                <span v-if="
                                                                    !$v
                                                                        .detail
                                                                        .quantity
                                                                        .greaterThanZero
                                                                ">This
                                                                    value
                                                                    must be
                                                                    greater
                                                                    than
                                                                    zero.</span>
                                                            </div>
                                                        </b-col>
                                                        <b-col sm="6">
                                                            <label for="total" class="mb-0">Total <small
                                                                    class="text-warning" v-if="item.type === 'CSE'">-
                                                                    with
                                                                    inflation rate of ({{ inflationRate &&
                                                                        inflationRate }})%</small>
                                                            </label>
                                                            <div class="
                                                                    d-flex
                                                                    align-items-baseline
                                                                ">
                                                                <div class="
                                                                        w-100
                                                                        me-2
                                                                    ">
                                                                    <masked-input autocomplete="off" id="total"
                                                                        type="text" v-model="detail.totalAmt" disabled
                                                                        class="form-control text-right"
                                                                        :mask="currencyMask"></masked-input>
                                                                </div>
                                                                <div class="
                                                                        d-flex
                                                                    ">
                                                                    <button type="submit" class="
                                                                            btn
                                                                            btn-primary
                                                                            me-1
                                                                        ">
                                                                        <i class="
                                                                                bx
                                                                                bx-plus
                                                                            "></i>
                                                                    </button>
                                                                    <button type="button" class="
                                                                            btn
                                                                            btn-light
                                                                        " @click="
                                                                            onResetDetail()
                                                                            ">
                                                                        <i class="
                                                                                bx
                                                                                bx-x
                                                                            "></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </b-col>
                                                    </b-row>
                                                </form>
                                                <div class="
                                                        d-flex
                                                        justify-content-between
                                                        align-items-center
                                                    ">
                                                    <div class="
                                                            d-flex
                                                            align-items-center
                                                        ">
                                                        <span class="
                                                                text-danger
                                                                mb-2
                                                            " v-if="
                                                                detailChecker ==
                                                                0 &&
                                                                detailError
                                                            "><i class="
                                                                    fas
                                                                    fa-hand-point-up
                                                                    pointing-animation-upward
                                                                    me-2
                                                                    font-size-16
                                                                "></i>Save Details
                                                            First</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div :class="{
                                                    'border-danger':
                                                        (detailChecker ==
                                                            0 &&
                                                            detailError) ||
                                                        totalBudget < 0,
                                                }">
                                                    <b-row class="mt-2">
                                                        <b-col sm="12">
                                                            <b-table striped hover :items="filteredItemDetails
                                                                " :fields="itemDetailFields
                                                                    " show-empty>
                                                                <template #empty="scope">
                                                                    <div class="
                                                                            text-center
                                                                        ">
                                                                        {{
                                                                            scope.emptyText
                                                                        }}
                                                                    </div>
                                                                </template>
                                                                <template #cell(quantity)="row">
                                                                    {{ numberWithCommas(row.value) }}
                                                                </template>
                                                                <template #cell(actions)="row">
                                                                    <b-dropdown class="card-drop" variant="dark"
                                                                        menu-class="dropdown-menu-end"
                                                                        toggle-class="p-0" v-if="!viewDetail">
                                                                        <template v-slot:button-content>
                                                                            <i class="mdi mdi-dots-horizontal fs-5"></i>
                                                                        </template>
                                                                        <b-dropdown-item @click="updateItemDetail(row)"
                                                                            variant="dark">
                                                                            <i
                                                                                class="bx bx-edit font-size-18 me-1"></i>Edit
                                                                        </b-dropdown-item>
                                                                        <b-dropdown-item @click="deleteItemDetail(row)"
                                                                            variant="danger">
                                                                            <i
                                                                                class="mdi mdi-trash-can font-size-18 me-1"></i>Delete
                                                                        </b-dropdown-item>
                                                                    </b-dropdown>
                                                                </template>
                                                                <template #custom-foot>
                                                                    <b-tr :class="{ 'border-danger': totalBudget < 0 }">
                                                                        <b-th>Total</b-th>
                                                                        <b-th>{{ numberWithCommas(quantityTotal)
                                                                            }}</b-th>
                                                                        <b-th>{{ formatCurrency(amountTotal) }}</b-th>
                                                                        <b-th>
                                                                        </b-th>
                                                                    </b-tr>
                                                                    <b-tr v-if="totalBudget < 0">
                                                                        <b-th colspan="2"></b-th>
                                                                        <b-th colspan="2" class="p-0">
                                                                            <small class="text-danger">Action will lead
                                                                                to negative balance.</small>
                                                                        </b-th>
                                                                    </b-tr>
                                                                </template>
                                                            </b-table>
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="text-right">
                                            <button type="button" class="btn btn-primary" @click="onSubmitResourceItem"
                                                v-if="!viewDetail">
                                                Save changes
                                            </button>
                                            <button type="button" class="btn btn-link" @click="closeModal">
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="position-fixed" :class="{ 'bli-option': showBLIScreen }">
            <div class="slide-option" :class="{ active: slideBLI }">
                <a href="javascript:void(0);" @click="openBLI" :style="bliBtn" v-if="showBLIBtn"><i class="
                            bx bx-caret-right
                            font-size-24
                            py-3
                            px-2
                            rounded
                            bg-secondary bg-soft
                            text-white
                        "></i></a>
                <div class="p-5" style="overflow-y: auto; height: 100vh">
                    <b-row>
                        <b-col sm="6" class="d-flex align-items-center">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0">List of Budget Line Items</h4>
                            </div>
                        </b-col>
                        <div class="col-md-6 text-right">
                            <div class="d-flex float-end">
                                <div id="tickets-table_filter" class="dataTables_filter me-1">
                                    <label class="d-inline-flex align-items-center">
                                        <b-form-input autocomplete="off" v-model="filterBudget" type="search"
                                            placeholder="Search Budget..." class="form-control"></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </b-row>
                    <div class="row">
                        <div class="col-lg-12">
                            <div>
                                <div class="table-responsive">
                                    <table class="
                                            table table-centered
                                            align-middle
                                            project-list-table
                                            border-collapse-none
                                        ">
                                        <thead>
                                            <tr>
                                                <th scope="col" width="50px"></th>
                                                <th scope="col">
                                                    Account Name
                                                </th>
                                                <th scope="col" width="200px">
                                                    Budget Allocated
                                                </th>
                                                <th scope="col" width="200px">
                                                    Total Consumed
                                                </th>
                                                <th scope="col" width="200px">
                                                    Balance
                                                </th>
                                                <!-- <th
                                                    scope="col"
                                                    width="150px"
                                                    class="text-center"
                                                >
                                                    Expiry
                                                </th> -->
                                                <th scope="col" width="150px" class="text-center">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="budgetBusy">
                                                <td colspan="6">
                                                    <div class="d-flex justify-content-center align-items-center">
                                                        <div class="preloader-component me-2">
                                                            <div class="status">
                                                                <div class="spinner-chase w-20px h-20px">
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <strong>Loading...</strong>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="budgetData.length == 0 && !budgetBusy">
                                                <td colspan="6" class="text-muted text-center">
                                                    <i class="dripicons-warning me-1"></i>No data found
                                                </td>
                                            </tr>
                                            <tr v-if="filteredBudget.length == 0 && filterBudget && !budgetBusy">
                                                <td colspan="6" class="text-muted text-center">
                                                    <i class="dripicons-warning me-1"></i>Search not found
                                                </td>
                                            </tr>
                                            <template v-for="y in filteredBudget">
                                                <tr :key="'A' + y.id"
                                                    style="background-color: transparent;box-shadow: none;">
                                                    <td colspan="2" class="pad-2rem">
                                                        <div class="
                                                                d-flex
                                                                align-item-center
                                                                cursor-pointer
                                                            " @click="
                                                                y.showData =
                                                                !y.showData
                                                                ">
                                                            <span class="
                                                                    bx
                                                                    text-warning
                                                                    me-1
                                                                "
                                                                :class="{ 'bx-plus': !y.showData, 'bx-minus': y.showData }"
                                                                style="line-height: unset;"></span>
                                                            <h5 class="
                                                                    text-dark
                                                                    mb-0
                                                                ">
                                                                {{ y.fsName }}
                                                            </h5>
                                                        </div>
                                                    </td>
                                                    <td class="py-2">
                                                        <h5 class="
                                                                text-dark
                                                                mb-0
                                                            ">
                                                            {{
                                                                formatCurrency(
                                                                    y.allocated
                                                                )
                                                            }}
                                                        </h5>
                                                    </td>
                                                    <td class="py-2">
                                                        <h5 class="
                                                                text-dark
                                                                mb-0
                                                            ">
                                                            {{
                                                                formatCurrency(
                                                                    getFundSourceTotal(
                                                                        y
                                                                    )
                                                                )
                                                            }}
                                                        </h5>
                                                    </td>
                                                    <td class="py-0">
                                                        <h5 class="
                                                                text-dark
                                                                mb-0
                                                            ">
                                                            {{
                                                                formatCurrency(
                                                                    getFundSourceBalance(
                                                                        y
                                                                    )
                                                                )
                                                            }}
                                                        </h5>
                                                    </td>
                                                    <!-- <td class="py-0"></td> -->
                                                    <td class="py-0"></td>
                                                </tr>
                                                <template v-if="y.showData">
                                                    <template v-for="(z, zIndex) in filteredBudgetChild(y.data)">
                                                        <tr class="classic-tr" :key="'B' + z.id">
                                                            <td colspan="6" class="
                                                                    pad-2rem-5px
                                                                    position-relative
                                                                ">
                                                                <div class="
                                                                        line-vertical-middle
                                                                    "></div>
                                                                <div class="
                                                                        d-flex
                                                                        align-items-center
                                                                    ">
                                                                    <div class="
                                                                            line-horizontal-middle
                                                                            w-20px
                                                                        "></div>
                                                                    <!-- <span
                                                                            class="
                                                                                bx
                                                                                bx-checkbox-square
                                                                                text-success
                                                                                me-1
                                                                            "
                                                                            style="
                                                                                line-height: unset;
                                                                            "
                                                                        ></span> -->
                                                                    <b class="
                                                                            text-dark
                                                                        ">{{
                                                                            z.key
                                                                        }}</b>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <template>
                                                            <!-- v-for="(w, wIndex) in filteredBudgetChild(z.data)" -->
                                                            <!-- <tr
                                                                :key="
                                                                    'W' + w.id
                                                                "
                                                                class="
                                                                    classic-tr
                                                                "
                                                            >
                                                                <td
                                                                    colspan="6"
                                                                    class="
                                                                        pad-2rem-5px
                                                                        position-relative
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            line-vertical-middle
                                                                        "
                                                                    ></div>
                                                                    <div
                                                                        class="
                                                                            d-flex
                                                                            align-items-center
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                line-horizontal-middle
                                                                                w-30px
                                                                            "
                                                                        ></div>
                                                                        <b
                                                                            class="
                                                                                text-dark
                                                                            "
                                                                        >
                                                                            {{
                                                                                w.key
                                                                            }}</b
                                                                        >
                                                                    </div>
                                                                </td>
                                                            </tr> -->
                                                            <tr v-for="(x, xIndex) in filteredBudgetChild(z.data)"
                                                                :key="x.id" class="classic-tr custom-border-2">
                                                                <td class="
                                                                        pl-5px
                                                                        position-relative
                                                                    ">
                                                                    <div class="
                                                                            line-vertical-middle
                                                                        " :class="{
                                                                            'bottom-50':
                                                                                filteredBudgetChild(y.data).length - 1 == zIndex &&
                                                                                filteredBudgetChild(z.data).length - 1 == xIndex
                                                                        }"></div>
                                                                    <div class="
                                                                            d-flex
                                                                            align-items-center
                                                                        ">
                                                                        <div class="
                                                                                line-horizontal-middle
                                                                                w-100
                                                                            "></div>
                                                                    </div>
                                                                </td>
                                                                <td class="
                                                                        bg-table-tr
                                                                    " :class="{
                                                                        'border-top-white':
                                                                            xIndex >
                                                                            0,
                                                                    }">
                                                                    <h5 class="
                                                                            text-truncate
                                                                            font-size-14
                                                                            mb-0
                                                                            d-flex
                                                                        ">
                                                                        <a href="javascript: void(0);" class="text-dark"
                                                                            @click="viewItems(x)"
                                                                            v-if="item.id == 0 && !selectedTransfer.id">
                                                                            {{ x.accountGroup }}
                                                                        </a>
                                                                        <a href="javascript: void(0);" class="text-dark"
                                                                            @click="transferHere(x)" v-else>
                                                                            {{ x.accountGroup }}
                                                                        </a>
                                                                    </h5>
                                                                    <!-- <small v-if="x
                                                                            .financeTemplateObjectOfExpenditure
                                                                            .prexc">{{
                                                                         x
                                                                            .financeTemplateObjectOfExpenditure
                                                                            .prexc
                                                                            .prexcName
                                                                    }}</small>
                                                                    <small v-else class="text-warning">
                                                                        Manually added by Delivery Unit
                                                                    </small> -->
                                                                </td>
                                                                <td class="
                                                                        bg-table-tr
                                                                    " :class="{
                                                                        'border-top-white':
                                                                            xIndex >
                                                                            0,
                                                                    }">
                                                                    {{
                                                                        formatCurrency(
                                                                            x.amount
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td class="
                                                                        bg-table-tr
                                                                    " :class="{
                                                                        'border-top-white':
                                                                            xIndex >
                                                                            0,
                                                                    }">
                                                                    {{
                                                                        formatCurrency(
                                                                            x.amount -
                                                                            x.balance
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td class="
                                                                        bg-table-tr
                                                                    " :class="{
                                                                        'border-top-white':
                                                                            xIndex >
                                                                            0,
                                                                    }">
                                                                    {{
                                                                        formatCurrency(
                                                                            x.balance
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td class="
                                                                        text-center
                                                                        bg-table-tr
                                                                    " :class="{
                                                                        'border-top-white':
                                                                            xIndex >
                                                                            0,
                                                                    }">
                                                                    <div class="
                                                                            d-flex
                                                                            justify-content-center
                                                                        ">
                                                                        <a href="javascript:void(0)"
                                                                            @click="viewItems(x)"
                                                                            v-if="item.id == 0 && !selectedTransfer.id"
                                                                            class="
                                                                                d-flex
                                                                                align-items-center
                                                                            ">
                                                                            <span :class="{
                                                                                'text-success':
                                                                                    selectedBLI &&
                                                                                    selectedBLI.id ==
                                                                                    x.id,
                                                                            }">{{
                                                                                !selectedBLI ||
                                                                                    selectedBLI.id !=
                                                                                    x.id
                                                                                    ? "Select LIB"
                                                                                    : "Selected"
                                                                            }}</span>
                                                                            <i v-if="
                                                                                !selectedBLI ||
                                                                                selectedBLI.id !=
                                                                                x.id
                                                                            " class="
                                                                                    fas
                                                                                    fa-hand-point-left
                                                                                    pointing-animation
                                                                                    text-white
                                                                                    font-size-18
                                                                                    text-primary
                                                                                    cursor-pointer
                                                                                "></i>
                                                                        </a>
                                                                        <a href="javascript:void(0)"
                                                                            @click="transferHere(x)"
                                                                            v-if="transferIfs(x)"
                                                                            class="d-flex align-items-center text-success">
                                                                            <span>Transfer Here</span>
                                                                            <i class="
                                                                                    fas
                                                                                    fa-hand-point-left
                                                                                    pointing-animation
                                                                                    text-white
                                                                                    font-size-18
                                                                                    text-primary
                                                                                    cursor-pointer
                                                                                "></i>
                                                                        </a>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <item-list ref="itemList" @dropData="dropItem($event)"></item-list>
        <unit ref="unit" @dropData="dropUnit($event)"></unit>
        <item-category @dropData="dropItemCat($event)"></item-category>
        <package-modal ref="pckModal" @dropData="selectPackage"></package-modal>
    </div>
</template>